import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas'
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';

import css from './SignaturePage.css';

const AboutPage = ({ intl }) => {
  const sigCanvas = useRef(null);
  const [trimmedDataURL, setTrimmedDataURL] = useState(null);
  const [blobSig, setBlobSig] = useState(null);

  function clear () {
    sigCanvas.current.clear()
  }

  function trim () {
    sigCanvas.current.getTrimmedCanvas().toBlob((blob) => {
      console.log(blob)
      setBlobSig(blob)
    })
    setTrimmedDataURL(sigCanvas.current.getTrimmedCanvas().toDataURL('image/png'))
  }

  return (
    <StaticPage
      title={intl.formatMessage({ id: 'AboutPage.pageTitle' })}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: intl.formatMessage({ id: 'AboutPage.pageTitle' }),
        name: intl.formatMessage({ id: 'AboutPage.pageTitle' }),
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div>
            xxxx
            <div className={css.sigContainer}>
            <SignatureCanvas
              penColor='green'
              canvasProps={{ height: 500, className: css.sigCanvas }}
              ref={sigCanvas}
            />
                  <div>
        <button className={css.buttons} onClick={clear}>Clear</button>
        <button className={css.buttons} onClick={trim}>Trim</button>
      </div>
      {trimmedDataURL
        ? <img className={css.sigImage} alt='signature' src={trimmedDataURL} />
        : null}
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default injectIntl(AboutPage);
